import React, { useState, useEffect } from 'react';
import { login } from '../api';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({ user_id: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { userLogin } = useAuth();

  const loginUser = async (event: any) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await login(formData);
      console.log('Login successful:', response.data);
      
      // Determine user role based on API response
      let userRole = 'employee'; // default role
      if (response.data.isSuperAdmin) {
        userRole = 'superadmin';
      } else if (response.data.isAdmin) {
        userRole = 'admin';
      }
      
      // Create user object with role information
      const userData = {
        ...response.data,
        role: userRole
      };
      
      userLogin(userData);
      
      // Navigate based on role
      if (userRole === 'superadmin') {
        navigate('/superadmin');
      } else if (userRole === 'admin') {
        navigate("/admin");
      } else {
        navigate('/employee');
      }
    } catch (error) {
      console.error('Login failed:', error);
      setLoading(false);
    }
  };

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="tracker-header">
          <h1>TRACKER</h1>
          <div className="animated-underline"></div>
        </div>
        <div className="login-card">
          <h2>Login</h2>
          <form onSubmit={loginUser}>
            <div className="input-group">
              <label htmlFor="user_id">User ID</label>
              <input
                type="text"
                id="user_id"
                name="user_id"
                value={formData.user_id}
                onChange={handleChange}
                required
                className="login-input"
                placeholder="Enter your user ID"
              />
            </div>

            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                className="login-input"
                placeholder="Enter your password"
              />
            </div>

            <button 
              type="submit" 
              className={`login-button ${loading ? 'loading' : ''}`}
              disabled={loading}
            >
              {loading ? (
                <div className="spinner">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ) : (
                'Login'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
